var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconElv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-670f721e-388a-462d-b47a-a2a6670556d0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-6911a08c-dfae-421f-b59f-1624011119ac{fill:#fff;}.uuid-cd0a6964-cfe9-43c3-87db-4754db0208d1{fill:#44b8f3;}.uuid-ac71a7aa-73b6-4739-bd50-ff92e69db50b{fill:#1a3673;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-ac71a7aa-73b6-4739-bd50-ff92e69db50b",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-b13ae92a-2583-44f8-896c-69cfb3ff3c2d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-8e363cf7-81e3-4224-97b0-c29d1f4cec92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-3feee976-015d-4222-83be-484d326b72ed",
    className: "uuid-cd0a6964-cfe9-43c3-87db-4754db0208d1",
    d: "m324,191.7l-68-67.98-68,67.98-25.74-25.71,93.74-93.72,93.74,93.72-25.74,25.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "uuid-ca04139e-5ccc-472e-a627-9f34b4ed98e9",
    className: "uuid-6911a08c-dfae-421f-b59f-1624011119ac",
    d: "m188.44,215.58h137.44v38.72h-96.03v47.01h82.77v39.05h-82.77v48.33h96.03v39.05h-137.44v-212.15Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElv);
export default __webpack_public_path__ + "static/media/icon_elv.7c0875011bdda1bd293ca788ad6c9db0.svg";
export { ForwardRef as ReactComponent };